import React, { useCallback, useEffect, useRef, useState } from 'react';

import ProductGrid from '../common/ProductGrid';
import CartModal from '../Mainpage/CartModal';
import LoginModal from '../Mainpage/LoginModal';
import useCartActions from '../../hooks/useCartActions';
import useWishlist from '../../hooks/useWishlist';
import { apiUrl } from '../../config/api';

/** Curated "you may also like" selection. */
const AlsoLike = ({ limit = 10, layout = 'grid' }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [loginShow, setLoginShow] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const isMounted = useRef(true);

  const fetchProducts = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(apiUrl('/api/like-products'));
      if (!response.ok) throw new Error('Failed to fetch products');
      const data = await response.json();
      if (!isMounted.current) return;
      setProducts(data?.liked_products || []);
      setError(null);
    } catch {
      if (isMounted.current) setError('We could not load these products.');
    } finally {
      if (isMounted.current) setLoading(false);
    }
  }, []);

  useEffect(() => {
    isMounted.current = true;
    fetchProducts();
    return () => {
      isMounted.current = false;
    };
  }, [fetchProducts]);

  const openLogin = useCallback(() => setLoginShow(true), []);
  const { addToCart, pendingVariantId } = useCartActions({
    onCartOpen: () => setShowCart(true),
    onLoginRequired: openLogin,
  });
  const { isWishlisted, toggleWishlist, pendingCode } = useWishlist({
    onLoginRequired: openLogin,
  });

  const closeModals = useCallback(() => {
    setLoginShow(false);
    setShowCart(false);
  }, []);

  return (
    <>
      <ProductGrid
        products={products.slice(0, limit)}
        loading={loading}
        error={error}
        onRetry={fetchProducts}
        skeletonCount={limit}
        layout={layout}
        emptyTitle="Nothing to show here yet"
        emptyDescription="Browse the full collection to find your next piece."
        isWishlisted={isWishlisted}
        onToggleWishlist={toggleWishlist}
        wishlistPending={pendingCode}
        onAddToCart={addToCart}
        cartPending={pendingVariantId}
      />

      <LoginModal show={loginShow} onClose={closeModals} />
      <CartModal show={showCart} onClose={closeModals} />
    </>
  );
};

export default AlsoLike;
